module.exports = __webpack_public_path__ + "static/community-slideshow-01@2x-a3921855fbe4e9504828397e8a8b1975.jpg";